import Image from "../../components/general/Image";
import { DummyProfile, Quote } from "../../constants/ImagePaths";
import { useMemo } from "react";

const TestimonialsCard = ({ showAll = false }) => {
    const testimonials = [
        {
            name: "Samantha R.",
            position: "CTO at Finedge",
            image: DummyProfile,
            quote: "We needed skilled developers fast, and they absolutely delivered. Within a week, we had a full team onboard and coding. Great communication, smooth process, and top-tier talent — couldn't ask for more."
        },
        {
            name: "David M.",
            position: "Head of Product at NovaTech",
            image: DummyProfile,
            quote: "ncredible experience. Our project deadlines were tight, and the developers we hired ramped up instantly. It's rare to find this level of technical skill and professionalism together."
        },
        {
            name: "Priya K.",
            position: "VP Engineering at BrightPath",
            image: DummyProfile,
            quote: "The hiring process was seamless. We interviewed three developers and hired two — both exceeded expectations from day one. Highly recommend for anyone tired of endless sourcing."
        },
        {
            name: "Mark L.",
            position: "CEO at ZenCloud Solutions",
            image: DummyProfile,
            quote: "Exceptional talent and a no-hassle process. It felt like we added full-time employees without the hiring overhead. Truly one of the best decisions we made for scaling our tech team."
        },
        {
            name: "Isabella V",
            position: "COO at Beacon Apps",
            image: DummyProfile,
            quote: "Finding developers who are not just technical but culturally aligned is tough. They nailed it. Our new team members blended right in and started contributing immediately."
        },
        {
            name: "Tom S.",
            position: "Director of Engineering at Verto Systems",
            image: DummyProfile,
            quote: "We’ve worked with many staffing partners — none made it this effortless. From request to onboarding, everything moved fast, and the quality of developers was outstanding."
        },
    ]

    const shrinkedTestimonials = useMemo(() => {
        if (showAll) return testimonials
        return testimonials.slice(0, 4)
    }, [testimonials, showAll])

    return (
        <div className="flex flex-col gap-[20px]">
            {
                shrinkedTestimonials.map((testimonial, index) => (
                    <div key={index} className="bg-[#2d2d2d] rounded-[10px] p-[20px]">
                        <Image className="mb-[10px]" src={Quote} alt="quote" />

                        <div className="flex items-start justify-start gap-[20px]">
                            <div>
                                <p className="text-[18px] font-semibold"> {testimonial.name} </p>
                                <p className="text-[14px] font-extralight"> {testimonial.position} </p>
                                <div className="flex items-center gap-[5px] mt-[10px]">
                                    {
                                        Array.from({ length: 5 }).map((_, i) => (
                                            <svg key={i} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-4 text-primary-color">
                                                <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z" clipRule="evenodd" />
                                            </svg>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>

                        <p className="text-[13px] font-extralight text-[#EFF1F6] mt-[10px]"> {testimonial.quote} </p>
                    </div>
                ))
            }
        </div>
    )
}

export default TestimonialsCard;